import { combineReducers } from 'redux'
import { reducer as form } from 'redux-form'

import auth_user from './authUser'
import doctor from './careProfessionals'
import configs from './configs'
import forms from './forms'
import patients from './patients'
import plus_user from './plusUsers'
import user from './user'

const appReducer = combineReducers({
  configs,
  form,
  user,
  patients,
  forms,
  doctor,
  plus_user,
  auth_user
})

const rootReducer = (state, action) => {
  if (action.type === 'CLEAR_STORAGE') {
    localStorage.clear()
    return appReducer(undefined, action)
  }
  return appReducer(state, action)
}
export default rootReducer



// WEBPACK FOOTER //
// ./src/store/index.ts